<script setup lang="ts">
import {ref} from 'vue'
import {getFileExt, getFileSize} from "@/utils/common.ts";
import {CustomFile, MyFileUploader} from "@/types";

const visible = ref(false)
const uploaderList = ref<MyFileUploader[]>([])
const upload = ref<HTMLInputElement>()

const show = () => {
  visible.value = true
}

const hide = () => {
  visible.value = false
}

const destroy = () => {
  uploaderList.value = []
  hide()
}

const emit = defineEmits(["onStartUpload"])

const onSureUpload = () => {
  emit("onStartUpload", uploaderList.value)
}

const onFileChange = (e: any) => {
  if (upload.value && upload.value.files) {
    for (let i = 0; i < upload.value.files.length; i++) {
      const file = upload.value.files[i] as CustomFile
      if (file) {
        file.ext = getFileExt(file.name)
        const fileUploader: MyFileUploader = {
          file: file,
          status: 0,
        }
        uploaderList.value.push(fileUploader)
      }
    }
  }
  e.target.value = ''
}

const remove = (index: number) => {
  uploaderList.value.splice(index, 1)
}

defineExpose({show, hide, destroy})
</script>

<template>
  <el-dialog v-model="visible" title="上传文件" align-center>
    <div class="py-.5rem">
      <label class="px-2rem py-.5rem bg-#FF6600CC text-white cursor-pointer rounded hover:bg-#f67139" for="upload">
        选择文档文件
      </label>
      <input accept=".pdf,.docx,.doc,.xls,.xlsx,.txt,.ppt,.pptx" ref="upload" type="file" multiple id="upload"
             class="hidden" @change="onFileChange"/>
    </div>
    <el-table :data="uploaderList">
      <el-table-column label="文件名">
        <template #default="scope">{{ scope.row.file.name }}</template>
      </el-table-column>
      <el-table-column label="大小">
        <template #default="scope">{{ getFileSize(scope.row.file.size) }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="danger" @click="remove(scope.$index)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="hide">取消</el-button>
        <el-button type="primary" @click="onSureUpload">
          确认上传
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>
</style>
